<template>
  <div
    class="flex w-full flex-row items-center justify-start space-x-2 bg-background px-6 py-3"
    :class="
      ['cancelled', 'failed', 'pending', 'voided'].includes(
        transaction.status
      )
        ? 'opacity-60'
        : ''
    "
  >
    <div>
      <p
        class="line-clamp-1 text-left text-sm font-semibold"
      >
        {{ formattedTime }}
      </p>
    </div>
    <div class="flex-1 space-x-2">
      <PaymentDetailChip :payment="transaction" />
      <template v-if="transaction.status === 'cancelled'">
        <span
          class="mr-4 text-sm font-semibold text-background-fg/40"
        >
          Cancelled
        </span>
      </template>
      <template v-else-if="transaction.status === 'failed'">
        <span
          class="mr-4 text-sm font-semibold text-background-fg/40"
        >
          Failed
        </span>
      </template>
      <template
        v-else-if="transaction.status === 'pending'"
      >
        <span
          class="mr-4 text-sm font-semibold text-background-fg/40"
        >
          Pending
        </span>
      </template>
      <template v-else-if="transaction.status === 'voided'">
        <span
          class="mr-4 text-sm font-semibold text-background-fg/40"
        >
          VOIDED
        </span>
      </template>
    </div>
    <div
      v-if="
        transaction.type === 'payment' ||
        transaction.type === 'refund'
      "
      class="flex min-w-12 justify-end text-right text-sm font-semibold"
    >
      <span
        v-if="
          transaction.transactionMethod === 'pos_card' &&
          transaction.isDcc &&
          transaction.isDccFieldsPopulated
        "
        class="mr-2 text-xs"
        :class="
          transaction.status === 'successful'
            ? {
                payment: 'text-background-fg/70',
                refund: 'text-error/70',
              }[transaction.type]
            : 'text-background-fg/40'
        "
      >
        <template v-if="transaction.type === 'refund'"
          >-</template
        >
        {{
          formatToCurrencyString(
            transaction.dccCardCurrencyAmount,
            transaction.dccCardholderCurrency
          )
        }}
      </span>
      <span
        class="font-semibold"
        :class="[
          transaction.status === 'successful'
            ? {
                payment: 'text-background-fg',
                refund: 'text-error',
              }[transaction.type]
            : 'text-background-fg/40',
          'min-w-12 text-right text-sm font-semibold',
        ]"
      >
        <template v-if="transaction.type === 'refund'"
          >-</template
        >
        {{
          formatToCurrencyString(
            transaction.amountTransactedTotal,
            transaction.currency
          )
        }}
      </span>
    </div>
    <div
      v-else-if="transaction.type === 'reversal'"
      class="font-semibold text-error"
    >
      REVERSAL
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ListTransactionsResponseItem } from "@/services/transactions/listTransactions"

const { formatToCurrencyString } = useCurrency()

const props = defineProps<{
  transaction: ListTransactionsResponseItem
}>()

const formattedTime = computed(() =>
  formatToTime(props.transaction.createdAt)
)
</script>
